import { render } from "./browse-scenarios.vue?vue&type=template&id=134f55a0&ts=true"
import script from "./browse-scenarios.vue?vue&type=script&lang=ts"
export * from "./browse-scenarios.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__